export const getServiceProps =  {
        title:"Services",
        subTitle:'Explore the wide range of pre-departure services that AdmissionBox has to offer.',
        noServiceCard:'Hi there, we are working on bringing to you the best of ancillary partners.Until then reaching out to your counsellor for further assistance.'
  
}